export default __webpack_public_path__ + "static/media/web.a04160af.jpg";